import '.aq{position:fixed;}.ssr-plugin'
import '.cs{top:0;}.ssr-plugin'
import '.c4{left:0px;}.ssr-plugin'
import '.c5{right:0px;}.ssr-plugin'
import '.fu{bottom:0px;}.ssr-plugin'
import '.h2{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.h3{z-index:998;}.ssr-plugin'
import '.h4{transition:opacity 0.3s ease;}.ssr-plugin'
import '.av{height:100vh;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.b2{background-color:var(--palette-white);}.ssr-plugin'
import '.h5{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.h6{z-index:999;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.an{justify-content:space-between;}.ssr-plugin'
import '.cd{padding:1.5rem;}.ssr-plugin'
import '.h7{border-bottom:var(--border-default);}.ssr-plugin'
import '.e{flex-shrink:0;}.ssr-plugin'
import '.ci{flex:1;}.ssr-plugin'
import '.be{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="aq cs c4 c5 fu h2 h3 h4"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="aq cs av h b2 h5 h6 l m"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="l aa an cd h7 e"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="ci be cd"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
